<template>
  <common-template>
      <div class="list">
        <ul class="breadcrumbs">
          <li class="breadcrumbs__link">
            <a href="#" @click="mixinTransition('/partner/index.html')">
              {{$t('取引先情報一覧')}}
            </a>
          </li>
          <li>
            {{ $t(pageTitle) }}
          </li>
        </ul>
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner table-list mb-5">
          <h2 class="title p-3 bg-light">{{ $t("取引先情報") }}</h2>
          <table class="table table-bordered mb-0">
            <tbody class="tbody">
              <tr>
                <td class="table-active text-left">{{ $t("取引先名") }}</td>
                <td class="text-left">{{ form.name }}</td>
              </tr>
              <tr>
                <td class="table-active text-left">{{ $t("カナ") }}</td>
                <td class="text-left">{{ form.kana }}</td>
              </tr>
              <tr>
                <td class="table-active text-left">{{ $t("管理番号") }}</td>
                <td class="text-left">{{ form.code }}</td>
              </tr>
              <tr>
                <td class="table-active text-left">{{ $t("取引関係") }}</td>
                <td class="text-left">
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.isCustomer"
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck1"
                      disabled
                    />
                    <label class="form-check-label" for="gridCheck1">{{ $t("得意先") }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.isSupplier"
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck2"
                      disabled
                    />
                    <label class="form-check-label" for="gridCheck2">{{ $t("仕入先") }}</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="table-active text-left wf-160">{{ $t("材料仕入先") }}</td>
                <td class="text-left">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" v-model="form.isMaterialSupplier" type="checkbox" id="gridCheck3" disabled />
                    <label class="form-check-label" for="gridCheck3">{{ $t("材料仕入先") }}</label>
                  </div>
                </td>
              </tr>
              <tr v-if="form.isSupplier || form.isMaterialSupplier">
                <td class="table-active text-left wf-120">{{ $t("外注工程") }}</td>
                <td class="text-left">
                  <div>
                    <label for="displayColor">
                      <tooltip
                        :text="$t('外注工程表示色')"
                        icon="fa-question-circle"
                        position="position-left-top"
                        :msg="$t('外注工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart)"
                        :msgMaxLength="$t('外注工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart).length"
                        :isDisplayColorBtn="false"
                      ></tooltip>
                    </label>
                    <div class="display-color-wrap">
                      <button
                        type="button"
                        class="form-control btn btn-color-circle"
                        style="cursor: not-allowed;"
                        :style="displayColorStyle"
                        @click="displayColorModalOpen"
                      >
                      </button>
                      <label class="col-sm-4 col-form-label">
                        {{ $t(displayColorName) }}
                      </label>
                    </div>
                    <p>
                      {{ $t("工程計画ルール") }}
                      <q-toggle
                        class="ml-4"
                        v-model="form.isOperativeNonRegularTime"
                        disable
                        :label="$t('会社情報で設定した休日を所要日数に含める')"
                      />
                    </p>
                  </div>
                  <div>
                    <p>{{ $t("工程区分") }}</p>
                    <template v-for="(item, index) in kinds">
                      <div
                        :key="`kind-${index}`"
                        class="form-check border-bottom"
                      >
                        <!-- <input
                          @change="changeMaterialSupplier($event, item.id)"
                          class="form-check-input mt-2"
                          type="checkbox"
                          :id="`kind-${index}`"
                        /> -->
                        <label
                          class="form-check-label"
                          :for="`kind-${index}`"
                          >{{ $t(item.messageKey) }}</label
                        >
                      </div>
                      <div
                        class="form-check form-check-inline mb-5 flex-wrap"
                        :key="`kindChildren-${index}`"
                      >
                        <template v-for="child in item.datas">
                          <label
                            class="form-check-label mt-2"
                            :key="`childLabel-${child.id}`"
                            v-if="!child.isMaterialPrepare"
                          >
                            <input
                              v-model="form.processKindIds"
                              class="form-check-input ml-3 mr-3"
                              type="checkbox"
                              :value="child.id"
                              :key="`childInput-${child.id}`"
                              disabled
                            />{{ $t(child.messageKey) }}
                          </label>
                        </template>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="button d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-light mr-5"
              data-toggle="modal"
              data-target="#partnerModal"
              @click="partnerModalOpen()"
            >{{ $t("編集") }}</button>
            <button type="button" class="btn btn-danger" @click="deleteAlert(form)">{{ $t("削除") }}</button>
          </div>
        </div>
        <div class="inner table-list">
          <h2 class="title p-3 bg-light">{{ $t("送り先と注文先") }}</h2>
          <table class="table table-bordered mb-0">
            <tbody class="tbody">
              <!-- <tr>
                <td>テスト送り先</td>
                <td>
                  <button
                    @click="orderingContactModalOpen()"
                    type="button"
                    class="btn btn-light mr-5"
                  >{{ $t("情報修正") }}</button>
                </td>
                <td>
                  <button type="button" class="btn btn-danger" @click="deleteAlert()">{{ $t("削除") }}</button>
                </td>
              </tr> -->
              <template v-if="!load && list.length">
                <tr v-for="(item, index) in list" :key="`ordering-${index}`">
                  <td>{{ item.name }}</td>
                  <td width="120" class="text-center">
                    <button
                      @click="orderingContactModalOpen(item.id)"
                      type="button"
                      class="btn btn-light mr-5"
                    >{{ $t("編集") }}</button>
                  </td>
                  <td width="100" class="text-center">
                    <button type="button" class="btn btn-danger" @click="deleteAlert(item,1)">{{ $t("削除") }}</button>
                  </td>
                </tr>
              </template>
              <template v-else-if="!load && !list.length">
                <tr>
                  <td rowspan="2" colspan="99" class="text-center">{{ $t("ノーデータメッセージ") }}</td>
                </tr>
              </template>
              <template v-else-if="load">
                <tr>
                  <td colspan="12">
                    <div class="d-flex justify-content-center m-5" v-if="load">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="inner d-flex justify-content-end mt-4 mb-4">
          <button
            @click="orderingContactModalOpen()"
            type="button"
            class="btn btn-success create-btn"
            data-toggle="modal"
            data-target="#orderingContactModal"
          >{{ $t("登録") }}</button>
        </div>
        <div class="inner table-list">
          <h2 class="title p-3 bg-light">{{ $t("担当者") }}</h2>
          <table class="table table-bordered mb-0">
            <tbody class="tbody">
              <template v-if="!load && partnerUsers.length">
                <td class="bg-light text-center" >{{ $t("担当者名") }}</td>
                <td class="bg-light text-center">{{ $t("部署") }}</td>
                <td class="bg-light"></td>
                <td class="bg-light"></td>
                <tr v-for="(item, index) in partnerUsers" :key="`partnerUsers-${index}`">
                  <td>{{ item.name }}</td>
                  <td>{{ getDepartmentName(item.orderingContactId) }}</td>
                  <td width="120" class="text-center">
                    <button
                      @click="partnerUserModalOpen(item.id)"
                      type="button"
                      class="btn btn-light mr-5"
                    >{{ $t("編集") }}</button>
                  </td>
                  <td width="100" class="text-center">
                    <button type="button" class="btn btn-danger" @click="deleteAlert(item,2)">{{ $t("削除") }}</button>
                  </td>
                </tr>
              </template>
              <template v-else-if="!load && !partnerUsers.length">
                <tr>
                  <td rowspan="2" colspan="99" class="text-center">{{ $t("ノーデータメッセージ") }}</td>
                </tr>
              </template>
              <template v-else-if="load">
                <tr>
                  <td colspan="12">
                    <div class="d-flex justify-content-center m-5" v-if="load">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="inner d-flex justify-content-end mt-4 mb-4">
          <button
            @click="partnerUserModalOpen()"
            type="button"
            class="btn btn-success create-btn"
            data-toggle="modal"
            data-target="#partnerUserModal"
          >{{ $t("登録") }}</button>
        </div>
      </div>
    <partner-modal
      @registed="getPartnerDetail()"
      @modalClose="getPartnerDetail()"
      :kinds="kinds"
      ref="partner"
    ></partner-modal>
    <ordering-contact-modal
      @registed="getPartnerOrderingContact()"
      @modalClose="getPartnerOrderingContact()"
      ref="ordering"
    ></ordering-contact-modal>
    <partner-user-modal
      @registed="getPartnerUser()"
      @modalClose="getPartnerUser()"
      :list="list"
      ref="partnerUser"
    ></partner-user-modal>
    <selectDisplayColorModal
      ref="selectDisplayColorModal"
      flg="modal-display-color modal-display-color-partner"
      :displayColorStyle="displayColorStyle"
      @modal-close="setDisplayColor">
    </selectDisplayColorModal>
  </common-template>
</template>

<script>
import selectDisplayColorModal from '@/components/selectDisplayColorModal.vue'
import tooltip from '@/components/tooltip.vue'
import config from '@/config'
import { mapGetters } from 'vuex'
import orderingContactModal from './orderingContactModal'
import partnerModal from './partnerModal'
import partnerUserModal from './partnerUserModal'
const orderingContactFormat = {
  partnerId: null,
  name: '',
  kana: '',
  code: '',
  zipcode: '',
  prefCode: '',
  address1: '',
  address2: '',
  address3: '',
  phoneNo: '',
  faxNo: '',
  countryCode: '',
  displayColor: config.processDisplayColors.green.val,
}
export default {
  data() {
    return {
      form: {
        displayColor: config.processDisplayColors.green.val,
        id: null,
        partnerUserId: null,
        name: '',
        kana: '',
        code: '',
        isCustomer: false,
        isSupplier: false,
        isOperativeNonRegularTime: true,
        countryCode: '',
      },
      kinds: [],
      orderingContactForm: orderingContactFormat,
      orderingContactStatus: 'new',
      list: [],
      partnerUsers: [],
      load: false,
      load_user: false,
      pageTitle: '取引先詳細',
    }
  },
  components: {
    partnerModal,
    orderingContactModal,
    partnerUserModal,
    tooltip,
    selectDisplayColorModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    await this.getPartnerDetail()
    await this.getPartnerOrderingContact()
    await this.getPartnerUser()
  },
  methods: {
    // 取引先詳細の取得
    async getPartnerDetail() {
      // パラメータがあれば、Formにデータを入れる
      const url = location.search
      const searchParams = new URLSearchParams(url)
      if (searchParams.get('id')) {
        this.form.id = searchParams.get('id')
      } else {
        window.location.href = process.env.NODE_ENV !== 'development' ? '/base/partner/index.html' : '/partner/index.html'
        return
      }
      try {
        await this.$store.dispatch('auth/user')
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/partners`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { id: this.form.id },
          }
        )
        for (let key of Object.keys(res.data[0])) {
          this.form[key] = res.data[0][key]
        }
        const kinds = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/process/kinds`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.kinds = kinds.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 送り先/手配部署一覧の一覧の取得
    async getPartnerOrderingContact() {
      // パラメータがあれば、Formにデータを入れる
      this.list = []
      this.load = true
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/ordering/contacts`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { partnerId: this.form.id },
          }
        )
        this.list = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    // 取引先担当者の一覧の取得
    async getPartnerUser() {
      // パラメータがあれば、Formにデータを入れる
      this.partnerUsers = []
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/partner/users`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { partnerId: this.form.id },
          }
        )
        this.partnerUsers = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 取引先情報の編集のモーダルを開いたときの処理
    partnerModalOpen() {
      this.$refs.partner.modalOpen(this.form)
    },
    // 送り先/手配部署の情報修正ならデータを書き換える
    orderingContactModalOpen(id = null) {
      this.$refs.ordering.modalOpen(id, this.form.id, this.form.countryCode)
    },
    partnerUserModalOpen(id = null) {
      this.$refs.partnerUser.modalOpen(id, this.form.id)
    },
    async deleteAlert(item, state = 0) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
      })
      if (confirm) {
        try {
          let url = ''
          switch (state) {
            case 0:
              url =
                '/partner'
              break
            case 1:
              url =
                '/ordering/contact'
              break
            case 2:
              url =
                '/partner/user'
              break
            default:
              url =
                '/partner'
              break
          }
          // await this.$axios.put(
          await this.$axios.delete(
            `${this.$appConfig.CommonApiUrl}${url}`,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
              params: { id: item.id },
            }
          )
          await this.getPartnerOrderingContact()
          await this.getPartnerUser()
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          if (state === 0) window.location.href = process.env.NODE_ENV !== 'development' ? '/base/partner/index.html' : '/partner/index.html'
        } catch (err) {
          this.$swal.close()
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    getDepartmentName(id) {
      const data = this.list.find(item => item.id === id)
      if (data) {
        return data.name
      }
      return ''
    },
    displayColorModalOpen() {
    },
    setDisplayColor(data) {
      if (data.hex) {
        this.form.displayColor = data.hex
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    displayColorName() {
      if (!this.form.displayColor) return config.processDisplayColors.green
      return Object.values(config.processDisplayColors).find(color => this.form.displayColor === color.val)?.name
    },
    displayColorStyle() {
      if (!this.form.displayColor)
        return {'background-color': '', 'border-color': ''}
      return {
        'background-color': this.form.displayColor,
        'border-color': this.form.displayColor,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.display-color-wrap {
  display: inline-block;
  margin: 0 1rem;
}
.btn-color-circle {
  height: 2.6rem;
}
</style>
